import script from "./ScheduleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleItem.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleItem.vue?vue&type=style&index=0&id=558e565b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558e565b"]])

export default __exports__